export type BinId = 'plastic' | 'paper' | 'canGlass' | 'vinyl' | 'general' | 'special';

export interface Bin {
  id: BinId;
  labelKo: string;
  color: string;
  descriptionKo: string;
}

export const BINS: Record<BinId, Bin> = {
  plastic: {
    id: 'plastic',
    labelKo: '플라스틱',
    color: '#3aa0ff',
    descriptionKo: '페트병, 플라스틱 용기 등 (라벨 제거·압착 후 배출)',
  },
  paper: {
    id: 'paper',
    labelKo: '종이',
    color: '#caa46a',
    descriptionKo: '종이류, 종이팩 (종이팩은 일반 종이와 구분 배출)',
  },
  canGlass: {
    id: 'canGlass',
    labelKo: '캔·유리',
    color: '#7bd67b',
    descriptionKo: '캔, 유리병 (깨진 유리는 제외)',
  },
  vinyl: {
    id: 'vinyl',
    labelKo: '비닐',
    color: '#f2d94e',
    descriptionKo: '비닐 포장재 (이물질 제거 후 배출)',
  },
  general: {
    id: 'general',
    labelKo: '일반쓰레기',
    color: '#8a8a8a',
    descriptionKo: '재활용이 어려운 복합재질·오염된 폐기물',
  },
  special: {
    id: 'special',
    labelKo: '특수배출함',
    color: '#d9534f',
    descriptionKo: '폐건전지·폐형광등·의류·폐가전 등 전용수거함',
  },
};

export const BIN_ORDER: BinId[] = ['plastic', 'paper', 'canGlass', 'vinyl', 'general', 'special'];
